import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
export const SocialProof = () => {
  // Helper function to render stars
  const renderStars = rating => {
    const stars = [];
    for (let i = 0; i < 5; i++) {
      stars.push(<StarIcon key={i} className={`w-5 h-5 ${i < rating ? 'text-yellow-500 fill-yellow-500' : 'text-gray-200'}`} data-id="element-545" />);
    }
    return <div className="flex" data-id="element-546">{stars}</div>;
  };
  return <section className="mb-10" data-id="element-547">
      <h2 className="text-xl font-bold text-blue-800 mb-6" data-id="element-548">
        Waarom andere hondenbezitters kiezen voor onze aanpak
      </h2>
      <div className="space-y-6 mb-8" data-id="element-549">
        <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-green-400" data-id="element-550">
          <div className="flex mb-3" data-id="element-551">
            <div className="mr-4 flex-shrink-0" data-id="element-552">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/gM7vPbvoBpXc27ky7MzpiP/freepik__a-warm-realistic-photo-of-a-dutch-nanny-in-her-40s__10368.png" alt="Nanny met ruwharige teckel Lucy" className="w-16 h-16 rounded-full object-cover" data-id="element-553" />
            </div>
            <div data-id="element-554">
              <div className="flex justify-between" data-id="element-555">
                <h3 className="font-bold" data-id="element-556">Nanny met ruwharige teckel Lucy</h3>
                {renderStars(5)}
              </div>
              <QuoteIcon className="w-6 h-6 text-green-300 mr-2 flex-shrink-0 float-left" data-id="element-557" />
              <p className="italic" data-id="element-558">
                "Vandaag 40 minuten (weg geweest)! De begeleiding gaat verder
                dan het leren alleen zijn."
              </p>
            </div>
          </div>
        </div>
        <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-green-400" data-id="element-559">
          <div className="flex mb-3" data-id="element-560">
            <div className="mr-4 flex-shrink-0" data-id="element-561">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/fYSHLyBZRU7Nu9eVmbuKVc/Scherm%C2%ADafbeelding_2025-09-16_om_22.59.41.png" alt="Martina met hond Lemmy" className="w-16 h-16 rounded-full object-cover" data-id="element-562" />
            </div>
            <div data-id="element-563">
              <div className="flex justify-between" data-id="element-564">
                <h3 className="font-bold" data-id="element-565">Martina met hond Lemmy</h3>
                {renderStars(5)}
              </div>
              <QuoteIcon className="w-6 h-6 text-green-300 mr-2 flex-shrink-0 float-left" data-id="element-566" />
              <p className="italic" data-id="element-567">
                "Hij kon geen 1 seconden alleen blijven. Nu na zes weken heb ik
                mijn leven weer terug. Vrijdag ben ik zelfs drie uur lang naar
                yoga geweest en Lemmy lag rustig thuis te slapen!"
              </p>
            </div>
          </div>
        </div>
        <div className="bg-gray-50 p-5 rounded-lg border-l-4 border-green-400" data-id="element-568">
          <div className="flex mb-3" data-id="element-569">
            <div className="mr-4 flex-shrink-0" data-id="element-570">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/x3bgEbVqTMxFNTTppm54GE/freepik__a-realistic-portrait-photo-of-a-smiling-dutch-woma__10369.png" alt="Frieda" className="w-16 h-16 rounded-full object-cover" data-id="element-571" />
            </div>
            <div data-id="element-572">
              <div className="flex justify-between" data-id="element-573">
                <h3 className="font-bold" data-id="element-574">Frieda</h3>
                {renderStars(5)}
              </div>
              <QuoteIcon className="w-6 h-6 text-green-300 mr-2 flex-shrink-0 float-left" data-id="element-575" />
              <p className="italic" data-id="element-576">
                "Aanrader! Zeer deskundige begeleiding! Onze hond kon echt niet
                alleen blijven, was heel angstig en begon dan te loeien. Na drie
                maanden kan ze met gemak 3 uur alleen blijven! Echt superfijn!
                De begeleiding is altijd bereikbaar, kijkt met je mee, heeft
                goede adviezen en stimuleert je om door te zetten. En nog super
                aardig ook! Zeker een aanrader en het geld waard!"
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-blue-50 p-6 rounded-lg mb-6 border border-blue-200" data-id="element-577">
        <h3 className="text-lg font-bold text-blue-800 mb-4" data-id="element-578">
          Onze resultaten spreken voor zich:
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-center" data-id="element-579">
          <div className="p-4 bg-white rounded-lg shadow-sm" data-id="element-580">
            <div className="text-3xl font-bold text-blue-600 mb-2" data-id="element-581">87%</div>
            <p className="text-sm" data-id="element-582">
              van onze cliënten bereikt hun doel binnen 3 maanden
            </p>
          </div>
          <div className="p-4 bg-white rounded-lg shadow-sm" data-id="element-583">
            <div className="text-3xl font-bold text-blue-600 mb-2" data-id="element-584">633</div>
            <p className="text-sm" data-id="element-585">Vijfsterren reviews op Trustpilot</p>
          </div>
          <div className="p-4 bg-white rounded-lg shadow-sm" data-id="element-586">
            <div className="text-3xl font-bold text-blue-600 mb-2" data-id="element-587">132</div>
            <p className="text-sm" data-id="element-588">succesvolle trajecten in 2025</p>
          </div>
        </div>
      </div>
      <div className="bg-gray-50 p-5 rounded-lg mb-6" data-id="element-589">
        <div className="flex items-start" data-id="element-590">
          <div className="mr-4 flex-shrink-0" data-id="element-591">
            <img src="https://images.unsplash.com/photo-1573497620053-ea5300f94f21?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=150&q=80" alt="Dr. Emma Verhoeven" className="w-16 h-16 rounded-full object-cover" data-id="element-592" />
          </div>
          <div data-id="element-593">
            <h3 className="font-bold mb-2" data-id="element-594">Expert Endorsement</h3>
            <p className="italic" data-id="element-595">
              "Als dierengedragstherapeut ben ik onder de indruk van deze
              aanpak. Door eerst de onderliggende oorzaak te identificeren,
              wordt de behandeling veel effectiever. Traditionele methoden voor
              verlatingsangst falen vaak omdat ze het symptoom behandelen, niet
              de oorzaak. Deze methode pakt het probleem bij de wortel aan."
            </p>
            <p className="text-right text-sm font-medium mt-2" data-id="element-596">
              - Dr. Emma Verhoeven, Dierengedragstherapeut
            </p>
          </div>
        </div>
      </div>
    </section>;
};